export default "__VITE_ASSET__B6N7OI78__"